module.exports = __webpack_public_path__ + "img/vertical_7_3_8023.1c73e8b9.png";